import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {CurrencyPipe, DatePipe, DecimalPipe, NgClass, PercentPipe} from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  WritableSignal
} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {Router} from "@angular/router";
import {StatusLabel} from '@components/commons/status-label/status-label';
import {AbrirSei} from '@components/commons/abrir-sei/abrir-sei';
import {SeiService} from '@core/services/sei.service';
import {ConfirmDialog} from "@components/dialogs/confirm-dialog/confirm-dialog";
import {IconAddComponent} from "@components/icons/icon-add/icon-add.component";
import {IconBoldClock} from "@components/icons/icon-bold-clock/icon-bold-clock";
import {IconBoldEdit} from "@components/icons/icon-bold-edit/icon-bold-edit";
import {IconBoldEyeComponent} from "@components/icons/icon-bold-eye/icon-bold-eye.component";
import {IconBoldTrash} from "@components/icons/icon-bold-trash/icon-bold-trash";
import {IconCloseSquareComponent} from "@components/icons/icon-close-square/icon-close-square.component";
import {IconExportComponent} from "@components/icons/icon-export/icon-export.component";
import {IconImportComponent} from "@components/icons/icon-import/icon-import.component";
import {Column} from '@core/models/column.model';
import {Notificacao} from "@core/models/notificacoes";
import {Paginator} from "@core/models/paginator";
import {EnumsService} from "@core/services/enums.service";
import {
  NotificacaoHistorico,
  NotificacaoLoteRequest,
  NotificacaoResumo,
  NotificacaoService,
  OpcoesFiltroNotificacao
} from "@core/services/notificacao.service";
import {ConcessionariaFilter} from "@pages/notificacoes/components/concessionaria-filter/concessionaria-filter";
import {ImportarArquivo} from "@pages/notificacoes/importar-arquivo/importar-arquivo";
import {HasPermissionDirective} from "@shared/directives/has-permission.directive";
import {StickyHorizontalScrollDirective} from "@shared/directives/sticky-horizontal-scroll.directive";
import {SmartTooltipDirective} from "@shared/directives/tooltip.directive";
import {DateUtils} from "@shared/utils/date.utils";
import {MessageService} from "primeng/api";
import {Button, ButtonIcon} from "primeng/button";
import {DatePicker} from "primeng/datepicker";
import {Dialog} from "primeng/dialog";
import {Fluid} from "primeng/fluid";
import {IconField} from 'primeng/iconfield';
import {InputIcon} from 'primeng/inputicon';
import {InputNumber} from "primeng/inputnumber";
import {InputText} from "primeng/inputtext";
import {PopoverModule} from 'primeng/popover';
import {Skeleton} from "primeng/skeleton";
import {TableLazyLoadEvent, TableModule} from "primeng/table";
import {Tooltip} from "primeng/tooltip";
import {debounceTime, distinctUntilChanged, forkJoin, map, Observable, shareReplay, Subject, Subscription, switchMap} from "rxjs";
import {Checkbox} from 'primeng/checkbox';
import {Ripple} from 'primeng/ripple';
import {IconBoldBroom} from '@components/icons/icon-bold-broom/icon-bold-broom';
import {MultiSelect} from 'primeng/multiselect';
import {Select} from 'primeng/select';
import {DataTableColumn} from '@core/models/data-table-columns';
import {Filters} from '@core/models/filters';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {ArquivoService} from '@core/services/arquivo.service';
import {AuthService} from '@core/services/auth.service';
import {PageableParams} from '@core/models/pageable-params';
import {PageResponse} from '@core/models/page-response';
import {environment} from '@environments/environment';

@Component({
  selector: 'app-notificacoes',
  imports: [
    AbrirSei,
    Button,
    IconImportComponent,
    IconExportComponent,
    IconAddComponent,
    TableModule,
    Tooltip,
    DatePipe,
    CurrencyPipe,
    InputText,
    ReactiveFormsModule,
    DatePicker,
    ButtonIcon,
    IconBoldEyeComponent,
    IconBoldEdit,
    IconBoldTrash,
    IconBoldClock,
    ConfirmDialog,
    Skeleton,
    PercentPipe,
    DecimalPipe,
    Dialog,
    IconCloseSquareComponent,
    Fluid,
    InputNumber,
    ImportarArquivo,
    IconField,
    InputIcon,
    StatusLabel,
    PopoverModule,
    SmartTooltipDirective,
    HasPermissionDirective,
    StickyHorizontalScrollDirective,
    Checkbox,
    Ripple,
    IconBoldBroom,
    MultiSelect,
    Select,
    FormsModule,
    NgClass,
    DragDropModule,
    ConcessionariaFilter,
  ],
  templateUrl: './notificacoes.html',
  styleUrl: './notificacoes.css'
})
export class Notificacoes extends Paginator implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('tableContainer') tableContainer!: ElementRef;
  @ViewChild('controlsRow') controlsRow!: ElementRef;
  @ViewChild('topSection') topSection!: ElementRef;
  protected tableScrollHeight: string = '400px';
  protected notificacoes: Notificacao[] = [];
  protected loading = false;
  protected showPagination: boolean = true;
  protected showConfirmDeleteDialog: boolean = false;
  protected itemToDeleteId: number | null = null;
  protected viewingItemId: number | null = null;
  protected expandedHistoricoId: number | null = null;
  protected historicoEntries: NotificacaoHistorico[] = [];
  protected historicoLoading = false;
  protected showViewDialog: boolean | WritableSignal<boolean> = false;
  protected showImportDialog: boolean | WritableSignal<boolean> = false;
  protected selectedColumns: DataTableColumn[] = [];
  protected filterForm!: FormGroup;
  protected viewForm!: FormGroup;
  protected dataTableColumns: DataTableColumn[] = [];
  protected isInitializing: boolean = true;
  protected selectedStatCard: string | null = null;
  protected resumo: NotificacaoResumo = {
    total: 0, valorTotal: 0,
    emAnalise: 0, valorEmAnalise: 0,
    tap: 0, valorTap: 0,
    arbitral: 0, valorArbitral: 0,
    acolhida: 0, valorAcolhida: 0,
    anuladaCancelada: 0, valorAnuladaCancelada: 0
  };
  protected resumoLoading = true;
  protected readonly statusPorCard: Record<string, string[]> = {
    emAnalise: ['EM ANÁLISE'],
    tap: ['TAP'],
    arbitral: ['ARBITRAL'],
    acolhida: ['ACOLHIDA'],
    anuladaCancelada: ['ANULADA', 'CANCELADA'],
  };
  protected exportLoading: boolean = false;
  protected virtualScrollItemSize = '40';
  protected selectedRows: Notificacao[] = [];
  protected bulkEditMode = false;
  protected showColumnFilters = true;
  // Em telas menores (notebook) o painel de resumo + concessionárias nasce recolhido
  // para sobrar espaço vertical pra tabela. O usuário pode alternar e a escolha é salva.
  protected showTopPanel = window.innerHeight >= 900;
  protected editingCell: {rowId: number; field: string} | null = null;
  protected showSaveEditsDialog = false;
  protected showDiscardEditsDialog = false;
  // Edição Rápida não salva mais a cada seleção: fica pendente até "Salvar Alterações",
  // pra escolher errado + corrigir não gerar 2 entradas no histórico. Chave "id::campo",
  // então corrigir um valor pendente só sobrescreve a entrada, não duplica.
  private pendingEdits = new Map<string, {rowId: number; field: string; raw: any; isDate: boolean}>();
  private turnOffBulkEditAfterDiscard = false;
  protected showTableConfigDialog = false;
  protected configColumns: Array<{col: DataTableColumn; visible: boolean; fixed: boolean}> = [];
  protected showExtraColumnsDialog = false;
  protected extraColumns: Array<{id: string; label: string; type: 'text' | 'number' | 'date'}> = [];
  protected extraData: Record<string, Record<string, string>> = {};
  protected newExtraColLabel = '';
  protected newExtraColType: 'text' | 'number' | 'date' = 'text';
  private resetDataToFirst = false;
  private service = inject(NotificacaoService);
  private arquivoService = inject(ArquivoService);
  private authService = inject(AuthService);
  // número SEI virou link: a extensão já mostra "Abrir … no SEI", sem o balão da célula
  protected seiAtivo = inject(SeiService).ativo;
  private http = inject(HttpClient);
  private mockData$ = this.http.get<any[]>('/assets/mock-notificacoes.json').pipe(shareReplay(1));
  private messageService = inject(MessageService);
  protected enumsService = inject(EnumsService);
  private fb = inject(FormBuilder);
  private router = inject(Router)
  private breakpointObserver = inject(BreakpointObserver);
  isMobile$: Observable<boolean> = this.breakpointObserver.observe([Breakpoints.Handset])
    .pipe(
      map(result => result.matches),
      shareReplay()
    );
  private readonly lazyLoadSubject = new Subject<TableLazyLoadEvent>();
  private lazyLoadSubscription!: Subscription;

  @HostListener('window:resize')
  onResize() {
    this.calculateTableHeight();
  }

  ngOnInit() {
    this.loadExtraColumns();
    this.loadColumnFiltersPref();
    this.loadTopPanelPref();
    this.loadResumo();
    this.enumsService.initEnums().then(() => {
      this.initDataTableColumns();
      this.initUserPreferences();
      this.initFilterForm();
      setTimeout(() => {
        this.isInitializing = false;
        setTimeout(() => this.calculateTableHeight(), 0);
      }, 500);
    });
    this.lazyLoadSubscription = this.lazyLoadSubject
      .pipe(
        debounceTime(50),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr))
      )
      .subscribe((event: TableLazyLoadEvent) => this.handleLazyLoad(event));
  }

  handleLazyLoad(event: TableLazyLoadEvent): void {
    console.log('LazyLoad executado');
    this.get(event);
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    console.log('on lazy load');
    this.lazyLoadSubject.next(event);
  }

  ngOnDestroy(): void {
    this.lazyLoadSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this.calculateTableHeight();
  }

  protected get(event?: TableLazyLoadEvent, resetDataToFirst = false) {
    if ((environment as any).local && !this.authService.getIdToken()) {
      this.loading = true;
      this.mockData$.subscribe(raw => {
        const filters = this.filterForm ? this.getFiltersFromTable() : {};
        let data = this.applyMockFilters([...raw], filters);
        if (event?.sortField) {
          const field = event.sortField as string;
          const order = (event.sortOrder as number) ?? 1;
          data.sort((a, b) => {
            const va = a[field] ?? '';
            const vb = b[field] ?? '';
            if (va < vb) return -1 * order;
            if (va > vb) return 1 * order;
            return 0;
          });
        }
        this.notificacoes = data;
        this.pagination.totalItems = data.length;
        this.loading = false;
      });
      return;
    }
    if (event && this.isInitializing) return;
    if (this.showPagination) this.loading = true;

    console.log('get()', this.pagination)
    const filters = this.getFiltersFromTable();
    let params = this.buildPageableParams(event, filters, this.showPagination);

    this.service.get(params).subscribe({
      next: (res) => {
        if (!res.content) {
          this.finalizeSuccessGetRequest(res);
          return;
        }

        if (!this.showPagination) {

          if (this.resetDataToFirst || resetDataToFirst) {
            console.log('resetDataToFirst', this.resetDataToFirst)
            this.notificacoes = res.content;
            this.pagination.page = 0;
            this.pagination.first = 0;
            this.finalizeSuccessGetRequest(res);
            return;
          } else if (this.notificacoes.length > 0) {
            console.log('notificacoes.length > 0')
            const idsExistentes = new Set(this.notificacoes.map(n => n.id));
            const novosSemDuplicados = res.content.filter(n => !idsExistentes.has(n.id));
            this.notificacoes.push(...novosSemDuplicados);
            this.finalizeSuccessGetRequest(res);
            return;
          } else {
            console.log('notificacoes.length == 0');
            this.notificacoes = res.content;
            this.pagination.page = 0;
            this.finalizeSuccessGetRequest(res);
            return;
          }
        } else {
          // modo paginado
          this.notificacoes = res.content;
          this.pagination.rows = res.size;
          this.pagination.first = res.number * res.size;
          this.pagination.last = this.pagination.first + res.numberOfElements;

          this.finalizeSuccessGetRequest(res);

        }

      },
      error: error => {
        console.error('[Notificacoes] Erro ao obter notificacoes', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail: 'Erro ao buscar notificações.'
        })
        this.loading = false;
        this.resetDataToFirst = false;
      }
    });
  }


  protected onClickCreate() {
    this.router.navigate(['controle-notificacoes/nova-notificacao']).then(() => {
      console.info('[Notificacoes] navigate to notificacoes/nova-notificacao')
    });
  }

  protected onClickEdit(id: number) {
    this.router.navigate([`controle-notificacoes/notificacao/${id}`]).then(() => {
      console.info(`[Notificacoes] navigate to notificacoes/notificacao/${id}`)
    });
  }

  protected onClickView(id: number) {
    if (!id) return;
    this.viewingItemId = id;
    this.expandedHistoricoId = null;
    this.historicoEntries = [];
    if ((environment as any).local && !this.authService.getIdToken()) {
      this.mockData$.subscribe(data => {
        const item = data.find(n => n.id === id);
        if (item) {
          this.initViewForm(item as Notificacao);
          this.showViewDialog = true;
          this.onClickHistorico(id);
        }
      });
      return;
    }
    this.service.getById(id).subscribe({
      next: (response: Notificacao) => {
        this.initViewForm(response);
        this.showViewDialog = true;
        this.onClickHistorico(id);
      },
      error: error => {
        console.error('[Notificacoes] Erro ao buscar dados da notificação pelo id fornecido: ', error?.error?.errors);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: error?.error?.message || 'Erro ao carregar os dados da notificação.',
        })
      }
    });
  }

  protected onClickDelete(id: number) {
    if (!id) return;
    this.itemToDeleteId = id;
    this.showConfirmDeleteDialog = true;
  }

  protected deleteOne() {
    if (!this.itemToDeleteId) return;
    this.service.delete(this.itemToDeleteId).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Notificação foi excluída.'
        });
        this.showConfirmDeleteDialog = false;
        this.itemToDeleteId = null;
        this.get(undefined, true);
        this.loadResumo();
      },
      error: error => {
        console.error('[Notificacoes] Erro ao excluir notificação: ', error?.error?.errors);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail: error?.error?.message || 'Erro desconhecido ao excluir notificação.',
        });
        this.showConfirmDeleteDialog = false;
      }
    });
  }

  protected onCancelDelete() {
    this.showConfirmDeleteDialog = false;
    this.itemToDeleteId = null;
  }

  protected toggleConcessionaria(nome: string) {
    const control = this.filterForm?.get('concessionaria');
    if (!control) return;
    const current: string[] = control.value ?? [];
    const next = current.includes(nome) ? current.filter(n => n !== nome) : [...current, nome];
    control.setValue(next.length ? next : null);
  }

  protected getResumoValor(card: string): number {
    switch (card) {
      case 'total': return this.resumo.valorTotal;
      case 'emAnalise': return this.resumo.valorEmAnalise;
      case 'tap': return this.resumo.valorTap;
      case 'arbitral': return this.resumo.valorArbitral;
      case 'acolhida': return this.resumo.valorAcolhida;
      case 'anuladaCancelada': return this.resumo.valorAnuladaCancelada;
      default: return 0;
    }
  }

  protected get hasActiveFilters(): boolean {
    if (!this.filterForm) return false;
    return !PageableParams.areFiltersEmpty(this.filterForm.value);
  }

  protected onStatCardClick(type: string) {
    if (this.selectedStatCard === type) {
      this.selectedStatCard = null;
      this.filterForm?.get('status')?.setValue(null, {emitEvent: false});
    } else {
      this.selectedStatCard = type;
      this.filterForm?.get('status')?.setValue(this.statusPorCard[type], {emitEvent: false});
    }
    this.get(undefined, true);
    this.loadResumo();
  }

  protected onClickClearFilters() {
    this.filterForm.reset({}, {emitEvent: false});
    this.selectedStatCard = null;
    this.get(undefined, true); // onclick clear filters
    this.loadResumo();
  }

  protected toggleBulkEdit() {
    if (this.bulkEditMode && this.pendingEdits.size > 0) {
      // Desativar com alterações pendentes = descartar; confirma antes.
      this.turnOffBulkEditAfterDiscard = true;
      this.showDiscardEditsDialog = true;
      return;
    }
    this.bulkEditMode = !this.bulkEditMode;
    if (!this.bulkEditMode) {
      this.selectedRows = [];
    }
  }

  protected isRowSelected(item: Notificacao): boolean {
    return this.selectedRows.some(r => r.id === item.id);
  }

  protected onRowClick(item: Notificacao) {
    if (!this.bulkEditMode) return;
    if (this.isRowSelected(item)) {
      this.selectedRows = this.selectedRows.filter(r => r.id !== item.id);
    } else {
      this.selectedRows = [...this.selectedRows, item];
    }
  }

  protected clearRowSelection() {
    this.selectedRows = [];
  }

  protected toggleAllRows() {
    if (this.selectedRows.length === this.notificacoes.length) {
      this.selectedRows = [];
    } else {
      this.selectedRows = [...this.notificacoes];
    }
  }

  protected allRowsSelected(): boolean {
    return this.notificacoes.length > 0 && this.selectedRows.length === this.notificacoes.length;
  }

  protected someRowsSelected(): boolean {
    return this.selectedRows.length > 0 && this.selectedRows.length < this.notificacoes.length;
  }

  protected startCellEdit(item: Notificacao, field: string, event: Event) {
    event.stopPropagation();
    this.editingCell = {rowId: item.id as number, field};
  }

  protected isEditingCell(rowId: number, field: string): boolean {
    return this.editingCell?.rowId === rowId && this.editingCell?.field === field;
  }

  protected stopCellEdit() {
    this.editingCell = null;
  }

  protected getEnumOption(options: any[] | undefined, nome: any): any | null {
    if (!options || !nome) return null;
    return options.find(o => o.nome === nome) ?? null;
  }

  protected parseDateForPicker(value: any): Date | null {
    if (!value) return null;
    return DateUtils.parseIsoDate(String(value));
  }

  protected onInlineFieldChange(item: Notificacao, field: string, value: any) {
    if (!value) return;
    const ids = this.isRowSelected(item) && this.selectedRows.length > 1
      ? this.selectedRows.map(r => r.id as number)
      : [item.id as number];

    ids.forEach(id => {
      this.pendingEdits.set(`${id}::${field}`, {rowId: id, field, raw: {id: value.id, nome: value.nome}, isDate: false});
    });

    this.notificacoes.filter(n => ids.includes(n.id as number))
      .forEach(n => (n as any)[field] = value.nome);

    this.editingCell = null;
  }

  protected onInlineDateChange(item: Notificacao, field: string, value: Date | null) {
    const ids = this.isRowSelected(item) && this.selectedRows.length > 1
      ? this.selectedRows.map(r => r.id as number)
      : [item.id as number];

    const dateStr = value ? DateUtils.toLocalDate(value) : null;
    if (!dateStr) return;

    ids.forEach(id => {
      this.pendingEdits.set(`${id}::${field}`, {rowId: id, field, raw: dateStr, isDate: true});
    });

    this.notificacoes.filter(n => ids.includes(n.id as number))
      .forEach(n => (n as any)[field] = dateStr);

    this.editingCell = null;
  }

  protected get pendingEditCount(): number {
    return this.pendingEdits.size;
  }

  protected hasPendingEdit(rowId: number, field: string): boolean {
    return this.pendingEdits.has(`${rowId}::${field}`);
  }

  protected onClickSalvarEdicoes() {
    if (this.pendingEdits.size === 0) return;
    this.showSaveEditsDialog = true;
  }

  protected cancelarSalvarEdicoes() {
    this.showSaveEditsDialog = false;
  }

  protected confirmarSalvarEdicoes() {
    const pendentes = [...this.pendingEdits.values()];
    if (pendentes.length === 0) return;

    // Agrupa por campo+valor (uma chamada por combinação distinta), em vez de uma por linha.
    const grupos = new Map<string, { field: string; raw: any; ids: number[] }>();
    for (const p of pendentes) {
      const valorChave = p.isDate ? p.raw : p.raw?.id;
      const chave = `${p.field}::${valorChave}`;
      const grupo = grupos.get(chave) ?? {field: p.field, raw: p.raw, ids: []};
      grupo.ids.push(p.rowId);
      grupos.set(chave, grupo);
    }

    const chamadas = [...grupos.values()].map(g =>
      this.service.atualizarLote({ids: g.ids, [g.field]: g.raw} as NotificacaoLoteRequest)
    );

    forkJoin(chamadas).subscribe({
      next: () => {
        const totalNotificacoes = new Set(pendentes.map(p => p.rowId)).size;
        this.messageService.add({
          severity: 'success', summary: 'Salvo!',
          detail: `${pendentes.length} alteração(ões) salva(s) em ${totalNotificacoes} notificação(ões).`,
          life: 3000
        });
        this.pendingEdits.clear();
        this.bulkEditMode = false;
        this.selectedRows = [];
        this.get(undefined, true);
      },
      error: err => this.messageService.add({
        severity: 'error', summary: 'Erro!',
        detail: err?.error?.message || 'Erro ao salvar as alterações.'
      })
    });
  }

  protected onClickDescartarEdicoes() {
    if (this.pendingEdits.size === 0) return;
    this.turnOffBulkEditAfterDiscard = false;
    this.showDiscardEditsDialog = true;
  }

  protected cancelarDescartarEdicoes() {
    this.showDiscardEditsDialog = false;
    this.turnOffBulkEditAfterDiscard = false;
  }

  protected confirmarDescartarEdicoes() {
    this.pendingEdits.clear();
    this.get(undefined, true); // recarrega do servidor pra desfazer os valores mostrados só localmente
    if (this.turnOffBulkEditAfterDiscard) {
      this.bulkEditMode = false;
      this.selectedRows = [];
      this.turnOffBulkEditAfterDiscard = false;
    }
  }

  protected get visibleColumnsCount(): number {
    return this.configColumns.filter(c => c.visible).length;
  }

  protected onOpenTableConfig() {
    const visibleFields = new Set(this.selectedColumns.map(c => c.field));
    const visible = this.selectedColumns.map(c => ({col: c, visible: true, fixed: c.fixed ?? false}));
    const hidden = this.dataTableColumns
      .filter(c => !visibleFields.has(c.field))
      .map(c => ({col: c, visible: false, fixed: false}));
    this.configColumns = [...visible, ...hidden];
    this.showTableConfigDialog = true;
  }

  protected onColumnDrop(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.configColumns, event.previousIndex, event.currentIndex);
  }

  protected applyTableConfig() {
    const visibleCols = this.configColumns.filter(c => c.visible);
    // Colunas fixadas vão no início, depois as demais
    const fixed = visibleCols.filter(c => c.fixed).map(c => ({...c.col, fixed: true}));
    const normal = visibleCols.filter(c => !c.fixed).map(c => ({...c.col, fixed: false}));
    this.selectedColumns = [...fixed, ...normal];
    this.showTableConfigDialog = false;
    this.saveUserPreferences();
  }

  protected resetTableConfig() {
    this.configColumns = this.colunasPadrao().map(c => ({col: c, visible: true, fixed: !!c.fixed}));
  }

  /** Todas as colunas na ordem padrão, com o Processo fixado na frente. */
  private colunasPadrao(): DataTableColumn[] {
    return this.dataTableColumns.map(c => ({...c, fixed: c.field === 'processo'}));
  }

  protected showAllColumns() {
    this.configColumns.forEach(c => c.visible = true);
  }

  protected hideAllColumns() {
    this.configColumns.forEach(c => c.visible = false);
  }

  protected onClickHistorico(id: number) {
    if (!id) return;
    if (this.expandedHistoricoId === id) {
      this.expandedHistoricoId = null;
      this.historicoEntries = [];
      return;
    }
    this.expandedHistoricoId = id;
    this.historicoEntries = [];
    this.historicoLoading = true;
    this.service.getHistorico(id).subscribe({
      next: (entries) => {
        this.historicoEntries = entries;
        this.historicoLoading = false;
      },
      error: error => {
        console.error('[Notificacoes] Erro ao buscar histórico da notificação: ', error?.error?.errors);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail: error?.error?.message || 'Erro ao carregar o histórico da notificação.'
        });
        this.historicoLoading = false;
        this.expandedHistoricoId = null;
      }
    });
  }

  protected isStatusOuFaseEvento(evento: NotificacaoHistorico): boolean {
    return evento.campo === 'Status' || evento.campo === 'Fase';
  }

  protected formatHistoricoEvento(evento: NotificacaoHistorico): string {
    const usuario = evento.usuario?.toUpperCase() || 'USUÁRIO DESCONHECIDO';
    if (evento.tipoEvento === 'CRIACAO') {
      return `NOTIFICAÇÃO CADASTRADA POR ${usuario}.`;
    }
    const anterior = evento.valorAnterior ?? '—';
    const novo = evento.valorNovo ?? '—';
    return `${usuario} ALTEROU ${evento.campo?.toUpperCase()} DE "${anterior}" PARA "${novo}".`;
  }

  protected exportarNotificacao(tipo: 'EXCEL' | 'PARQUET') {
    this.exportLoading = true;
    this.messageService.add({
      severity: 'info',
      summary: 'Em andamento',
      detail: 'A exportação será concluída em alguns instantes. Por favor, aguarde.',
      life: 5000
    })
    const filters = PageableParams.cleanFilters(this.filterForm.value, this.dataTableColumns)
    this.arquivoService.exportWithFilters(tipo, filters).subscribe({
      next: (response) => {
        this.downloadDocumentFile(response, tipo);
        setTimeout(() => {
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso!',
            detail: 'Notificações exportadas com sucesso.',
          })
          this.exportLoading = false;
        }, 1000)
      },
      error: error => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro!',
          detail: 'Erro ao exportar as notificações.'
        })
        console.error('[Notificacoes] Erro ao exportar notificacoes: ', error)
        this.exportLoading = false;
      }
    })
  }

  protected getNumberOfRows() {
    if (this.showPagination) {
      return this.pagination.rows
    }
    return 10;
  }

  /** "A, B" -> ["A", "B"]: a Localização com várias unidades aparece uma em cada linha. */
  protected linhasLocalizacao(valor: string): string[] {
    return valor.split(',').map(u => u.trim()).filter(Boolean);
  }

  protected formatTooltip(item: Record<string, unknown>, column: Column): string {
    const value = item[column.field];

    switch (column.format) {
      case 'date':
        return typeof value === 'string' || value instanceof Date
          ? new Intl.DateTimeFormat('pt-BR').format(new Date(value))
          : '-';

      case 'currency':
        return typeof value === 'number'
          ? new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(value)
          : '-';

      case 'percent':
        return typeof value === 'number'
          ? new Intl.NumberFormat('pt-BR', {style: 'percent', minimumFractionDigits: 2}).format(
            value / 100
          )
          : '-';

      case 'status':
        return value != null ? String(value) : '-';

      default:
        return value != null ? String(value) : '-';
    }
  }

  protected trackByIndex(index: number): number {
    return index;
  }

  protected onSort(event: unknown) {
    this.pagination.page = 0;
    this.resetDataToFirst = true;
    this.showPagination = true;
  }

  protected onChangeShowPagination() {
    if (this.showPagination) {
      this.pagination.rows = 10;
      this.get({first: 0, rows: 10}, true); // onchange showpagination
    } else {
      this.get({first: 0}, true); // onchange showpagination
    }
    this.saveUserPreferences();
  }

  protected saveUserPreferences() {
    const selectedColumns = this.selectedColumns.map(column => column.field);
    const fixedColumns = this.selectedColumns.filter(c => c.fixed).map(c => c.field);
    const showPagination = this.showPagination;

    this.authService.setPreferences({selectedColumns, showPagination, fixedColumns}).subscribe({
      next: () => {
        console.info('[Notificacoes] preferências do usuário salvas com sucesso.')
      },
      error: error => {
        console.error('[Notificacoes] erro ao salvar preferências do usuário.', error)
      }
    });
  }

  protected openExtraColumnsDialog() {
    this.showExtraColumnsDialog = true;
  }

  protected addExtraColumn() {
    if (!this.newExtraColLabel.trim()) return;
    const id = 'extra_' + Date.now();
    this.extraColumns.push({id, label: this.newExtraColLabel.trim(), type: this.newExtraColType});
    this.newExtraColLabel = '';
    this.saveExtraColumns();
  }

  protected removeExtraColumn(id: string) {
    this.extraColumns = this.extraColumns.filter(c => c.id !== id);
    this.saveExtraColumns();
  }

  protected getExtraValue(rowId: number | undefined, colId: string): string {
    if (rowId == null) return '';
    return this.extraData[String(rowId)]?.[colId] ?? '';
  }

  protected setExtraValue(rowId: number | undefined, colId: string, value: string) {
    if (rowId == null) return;
    if (!this.extraData[String(rowId)]) this.extraData[String(rowId)] = {};
    this.extraData[String(rowId)][colId] = value;
    this.saveExtraData();
  }

  protected toggleColumnFilters() {
    this.showColumnFilters = !this.showColumnFilters;
    try {
      localStorage.setItem('notificacoes_show_filters', this.showColumnFilters ? '1' : '0');
    } catch {}
  }

  private loadColumnFiltersPref() {
    try {
      // Padrão: filtros expandidos. Só respeita o localStorage se o usuário já escolheu.
      const saved = localStorage.getItem('notificacoes_show_filters');
      if (saved !== null) this.showColumnFilters = saved === '1';
    } catch {}
  }

  protected toggleTopPanel() {
    this.showTopPanel = !this.showTopPanel;
    try {
      localStorage.setItem('notificacoes_show_top_panel', this.showTopPanel ? '1' : '0');
    } catch {}
    setTimeout(() => this.calculateTableHeight(), 50);
  }

  private loadTopPanelPref() {
    try {
      const saved = localStorage.getItem('notificacoes_show_top_panel');
      if (saved !== null) this.showTopPanel = saved === '1';
    } catch {}
  }

  private loadExtraColumns() {
    try {
      const saved = localStorage.getItem('notificacoes_extra_columns');
      if (saved) this.extraColumns = JSON.parse(saved);
      const savedData = localStorage.getItem('notificacoes_extra_data');
      if (savedData) this.extraData = JSON.parse(savedData);
    } catch {}
  }

  private saveExtraColumns() {
    localStorage.setItem('notificacoes_extra_columns', JSON.stringify(this.extraColumns));
  }

  private saveExtraData() {
    localStorage.setItem('notificacoes_extra_data', JSON.stringify(this.extraData));
  }

  private loadResumo() {
    const qs = this.filterForm
      ? this.buildPageableParams(undefined, this.getFiltersFromTable(), true).onlyFiltersToQueryString()
      : '';
    this.resumoLoading = true;
    this.service.getResumo(qs).subscribe({
      next: (res) => {
        this.resumo = res;
        this.resumoLoading = false;
      },
      error: () => {
        if ((environment as any).local) {
          const sum = (arr: any[]) => arr.reduce((acc, n) => acc + (n.valorAtual || 0), 0);
          const byStatus = (mocks: any[], status: string[]) => mocks.filter(n => status.includes(n.status));
          const filters = this.filterForm ? this.getFiltersFromTable() : {};
          this.mockData$.subscribe(allMocks => {
            const mocks = this.applyMockFilters([...allMocks], filters);
            const emAnalise = byStatus(mocks, this.statusPorCard['emAnalise']);
            const tap = byStatus(mocks, this.statusPorCard['tap']);
            const arbitral = byStatus(mocks, this.statusPorCard['arbitral']);
            const acolhida = byStatus(mocks, this.statusPorCard['acolhida']);
            const anuladaCancelada = byStatus(mocks, this.statusPorCard['anuladaCancelada']);
            this.resumo = {
              total: mocks.length,
              valorTotal: sum(mocks),
              emAnalise: emAnalise.length,
              valorEmAnalise: sum(emAnalise),
              tap: tap.length,
              valorTap: sum(tap),
              arbitral: arbitral.length,
              valorArbitral: sum(arbitral),
              acolhida: acolhida.length,
              valorAcolhida: sum(acolhida),
              anuladaCancelada: anuladaCancelada.length,
              valorAnuladaCancelada: sum(anuladaCancelada),
            };
            this.resumoLoading = false;
          });
          return;
        }
        this.resumoLoading = false;
      }
    });
  }

  private finalizeSuccessGetRequest(res: PageResponse<Notificacao>) {
    this.pagination.totalItems = res.totalElements;
    this.pagination.page = res.number;
    this.loading = false;
    this.resetDataToFirst = false;
  }

  private calculateTableHeight() {
    const windowHeight = window.innerHeight;

    const topSectionHeight = this.topSection?.nativeElement?.offsetHeight || 0;
    const controlsRowHeight = this.controlsRow?.nativeElement?.offsetHeight || 0;

    // card1 engloba controlsRow + a própria tabela, então seu offsetHeight não entra aqui:
    // a tabela é o que sobra dentro de card1 depois do controlsRow (senão o cálculo fica
    // circular e o scrollHeight resultante encolhe pra quase zero).
    const scrollHeight = windowHeight
      - 64  // header
      - 36  // padding do main (pt-3 + pb-6)
      - 16  // gap entre topSection e o card da tabela
      - topSectionHeight // cards de resumo + filtro de concessionárias + linha de filtros
      - controlsRowHeight

    // evita altura negativa/zero quando o painel de topo esta aberto em tela pequena
    this.tableScrollHeight = `${Math.max(scrollHeight, 120)}px`;
  }

  private downloadDocumentFile(response: HttpResponse<Blob>, tipo: 'EXCEL' | 'PARQUET') {
    const contentDisposition = response.headers.get('content-disposition');
    let fileName = tipo === 'EXCEL' ? 'export.xlsx' : 'export.parquet';
    if (contentDisposition) {
      const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match && match[1]) {
        fileName = match[1].replace(/['"]/g, '');
      }
    }
    const blob = response.body as Blob;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  private getFiltersFromTable(): Filters {
    const filters: Filters = {...this.filterForm.value};

    if (filters.avanco != null && typeof filters.avanco === 'string') {
      filters.avanco = filters.avanco.replace(',', '.');
    }

    return filters;
  }

  private initUserPreferences(): void {
    this.authService.getPreferences().subscribe({
      next: (response) => {
        if (response) {
          if (response.showPagination !== undefined) {
            this.showPagination = response.showPagination;
          }
          if (response.selectedColumns) {
            const colMap = new Map(this.dataTableColumns.map(c => [c.field, c]));
            const fixedSet = new Set(response.fixedColumns ?? []);
            const salvas = response.selectedColumns
              .map(f => colMap.get(f))
              .filter((c): c is DataTableColumn => c !== undefined)
              .map(c => ({...c, fixed: fixedSet.has(c.field)}));
            const jaSalvos = new Set(salvas.map(c => c.field));
            const novasColunas = this.dataTableColumns.filter(c => !jaSalvos.has(c.field));
            this.selectedColumns = [...salvas, ...novasColunas];
          } else {
            this.selectedColumns = this.colunasPadrao();
          }
        } else {
          this.selectedColumns = this.colunasPadrao();
        }
      },
      error: error => {
        console.error('[Notificacoes] Erro ao obter as preferências do usuário', error);
        this.selectedColumns = this.colunasPadrao();
      }
    })

  }

  private initFilterForm() {
    const controlsConfig = this.dataTableColumns.reduce((acc, col) => {
      switch (col.format) {
        case 'text':
          acc[col.field] = [''];
          break;
        default:
          acc[col.field] = [null];
      }
      return acc;
    }, {} as Record<string, any>);

    this.filterForm = this.fb.group(controlsConfig);

    if (this.filterForm) {
      this.dataTableColumns.forEach((col) => {
        const control = this.filterForm.get(col.field);
        if (!control) return;

        control.valueChanges
          .pipe(debounceTime(300), distinctUntilChanged())
          .subscribe((value) => {
            if (col.format === 'text') {
              // Sem mínimo de caracteres: bloquear em 3 impedia achar NOT/TAP com poucos
              // dígitos ou com zeros à esquerda (ex.: "7", "007"). O debounce acima já
              // evita disparo a cada tecla.
              this.get(undefined, true);
              this.loadResumo();
            } else {
              this.get(undefined, true);
              this.loadResumo();
            }
          });
      });

      // Filtros em cascata: refaz as opções dos selects considerando os OUTROS filtros já
      // ativos (ignora o próprio campo), e remove da seleção o que sumiu. switchMap cancela
      // uma busca de opções desatualizada se o usuário filtrar de novo antes dela voltar.
      this.filterForm.valueChanges
        .pipe(
          debounceTime(300),
          distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
          switchMap(() => this.service.getOpcoesFiltro(
            this.buildPageableParams(undefined, this.getFiltersFromTable(), true).onlyFiltersToQueryString(),
          )),
        )
        .subscribe({
          next: opcoes => this.aplicarOpcoesFiltro(opcoes),
          error: () => {
          }, // silencioso: nao trava a tela principal se essa chamada auxiliar falhar
        });

      // 1ª busca de opções assim que o form existe (reflete o catálogo inteiro sem filtro nenhum).
      this.service.getOpcoesFiltro('').subscribe({
        next: opcoes => this.aplicarOpcoesFiltro(opcoes),
        error: () => {
        },
      });
    }
  }

  private catalogoPorCampo(field: string): any[] {
    switch (field) {
      case 'superintendencia': return this.enumsService.superintendencias;
      case 'diretoria': return this.enumsService.diretorias;
      case 'motivo': return this.enumsService.motivos;
      case 'status': return this.enumsService.status;
      case 'fase': return this.enumsService.fases;
      case 'curso': return this.enumsService.cursos;
      case 'grupo': return this.enumsService.grupos;
      case 'nivel': return this.enumsService.niveis;
      case 'tipoTap': return this.enumsService.tiposTap;
      case 'situacaoTap': return this.enumsService.situacoesTap;
      case 'concessionaria': return this.enumsService.concessionarias;
      default: return [];
    }
  }

  private aplicarOpcoesFiltro(opcoes: OpcoesFiltroNotificacao) {
    const disponiveisPorCampo: Record<string, string[] | undefined> = {
      superintendencia: opcoes.superintendencia,
      diretoria: opcoes.diretoria,
      motivo: opcoes.motivo,
      status: opcoes.status,
      fase: opcoes.fase,
      curso: opcoes.curso,
      grupo: opcoes.grupo,
      nivel: opcoes.nivel,
      tipoTap: opcoes.tipoTap,
      situacaoTap: opcoes.situacaoTap,
      concessionaria: opcoes.concessionaria,
    };

    // dataTableColumns e selectedColumns guardam cópias separadas de cada coluna
    // (initUserPreferences espalha {...c}), então as duas precisam ser atualizadas.
    // Só filterOptions é estreitado — options fica intacto (usado pela Edição Rápida,
    // que não deve ficar restrita ao que já está filtrado na tabela).
    [this.dataTableColumns, this.selectedColumns].forEach(colunas => {
      colunas.forEach(col => {
        const disponiveis = disponiveisPorCampo[col.field];
        if (!disponiveis) return;
        const catalogo = this.catalogoPorCampo(col.field);
        col.filterOptions = catalogo.filter((o: any) => disponiveis.includes(o.nome));
      });
    });

    Object.keys(disponiveisPorCampo).forEach(field =>
      this.removerSelecaoObsoleta(field, disponiveisPorCampo[field]));
  }

  /** Tira da seleção do campo os valores que não estão mais entre as opções disponíveis. */
  private removerSelecaoObsoleta(campo: string, disponiveis: string[] | undefined) {
    const control = this.filterForm?.get(campo);
    if (!control || !disponiveis) return;
    const atual = control.value;
    if (!Array.isArray(atual) || atual.length === 0) return;
    const sobreviventes = atual.filter((v: string) => disponiveis.includes(v));
    if (sobreviventes.length !== atual.length) {
      control.setValue(sobreviventes.length ? sobreviventes : null);
    }
  }

  private initViewForm(notificacao: Notificacao) {
    this.viewForm = this.fb.group({
      superintendencia: [{
        value: this.enumsService.getLabelFromEnum(notificacao.superintendencia) || null,
        disabled: true
      }],
      diretoria: [{value: this.enumsService.getLabelFromEnum(notificacao.diretoria) || null, disabled: true}],
      gerencia: [{value: notificacao.gerencia || '', disabled: true}],
      cff: [{value: notificacao.cff || '', disabled: true}],
      numeroNotificacao: [{value: notificacao.numeroNotificacao || null, disabled: true}],
      dataNotificacao: [{
        value: DateUtils.parseIsoDate(notificacao.dataNotificacao || ''),
        disabled: true
      }],
      concessionaria: [{
        value: this.enumsService.getLabelFromEnum(notificacao.concessionaria) || '',
        disabled: true
      }],

      categoria: [{value: notificacao.categoria || null, disabled: true}],
      processo: [{value: notificacao.processo || null, disabled: true}],
      descricao: [{value: notificacao.descricao || null, disabled: true}],
      motivo: [{value: this.enumsService.getLabelFromEnum(notificacao.motivo) || null, disabled: true}],
      status: [{value: this.enumsService.getLabelFromEnum(notificacao.status) || null, disabled: true}],
      dataStatus: [{
        value: DateUtils.parseIsoDate(notificacao.dataStatus || ''),
        disabled: true
      }],
      fase: [{value: this.enumsService.getLabelFromEnum(notificacao.fase) || null, disabled: true}],
      dataFase: [{
        value: DateUtils.parseIsoDate(notificacao.dataFase || ''),
        disabled: true
      }],
      valorP0: [{value: notificacao.valorP0 || null, disabled: true}],
      valorAtual: [{value: notificacao.valorAtual || null, disabled: true}],
      numeroTap: [{value: notificacao.numeroTap || null, disabled: true}],
      tipoTap: [{value: this.enumsService.getLabelFromEnum(notificacao.tipoTap) || null, disabled: true}],
      dataTap: [{
        value: DateUtils.parseIsoDate(notificacao.dataTap || ''),
        disabled: true
      }],
      valorTap: [{value: notificacao.valorTap || null, disabled: true}],
      situacaoTap: [{value: this.enumsService.getLabelFromEnum(notificacao.situacaoTap) || null, disabled: true}],
      andamento: [{
        value: DateUtils.parseIsoDate(notificacao.andamento || ''),
        disabled: true
      }],
      rodovia: [{value: this.enumsService.getLabelFromEnum(notificacao.rodovia) || null, disabled: true}],
      localizacao: [{value: notificacao.localizacao || null, disabled: true}],
      infracoes: [{value: notificacao.infracoes || null, disabled: true}],
      grupo: [{value: this.enumsService.getLabelFromEnum(notificacao.grupo) || null, disabled: true}],
      nivel: [{value: this.enumsService.getLabelFromEnum(notificacao.nivel) || null, disabled: true}],
      avanco: [{value: notificacao.avanco || null, disabled: true}],
      judicial: [{value: notificacao.judicial || null, disabled: true}],
      observacao: [{value: notificacao.observacao || null, disabled: true}],
      curso: [{value: this.enumsService.getLabelFromEnum(notificacao.curso) || null, disabled: true}],
    });
  }

  private applyMockFilters(data: any[], rawFilters: any): any[] {
    const colFormatMap = new Map(this.dataTableColumns.map(c => [c.field, c.format]));
    return data.filter(item => {
      for (const [key, value] of Object.entries(rawFilters)) {
        if (value === null || value === undefined || value === '') continue;
        if (Array.isArray(value) && value.length === 0) continue;

        const format = colFormatMap.get(key);
        const itemVal = item[key];

        if (format === 'daterange') {
          if (!Array.isArray(value)) continue;
          const [start, end] = value as (Date | null)[];
          const d = itemVal ? new Date(itemVal + 'T00:00:00') : null;
          if (!d) { if (start || end) return false; continue; }
          if (start && d < start) return false;
          if (end) { const endDay = new Date(end); endDay.setHours(23, 59, 59); if (d > endDay) return false; }
          continue;
        }

        if (format === 'status' || format === 'select') {
          if (Array.isArray(value)) {
            const names = (value as any[]).map(v => (typeof v === 'object' && v !== null) ? v.nome : v);
            if (names.length > 0 && !names.includes(itemVal)) return false;
          } else if (typeof value === 'object' && value !== null && (value as any).nome !== undefined) {
            if (itemVal !== (value as any).nome) return false;
          } else if (typeof value === 'string') {
            if (itemVal !== value) return false;
          }
          continue;
        }

        if (format === 'text') {
          const str = String(value).trim();
          if (!str) continue;
          if (itemVal === null || itemVal === undefined) return false;
          if (!String(itemVal).toLowerCase().includes(str.toLowerCase())) return false;
          continue;
        }
      }
      return true;
    });
  }

  private initDataTableColumns(): void {
    // Processo na frente e fixada por padrão (ver colunasPadrao)
    this.dataTableColumns = [
      {label: 'Processo', field: 'processo', sortable: true, format: 'text'},
      {label: 'Superintendência', field: 'superintendencia', sortable: true, format: 'select', options: this.enumsService.superintendencias, quickEdit: true},
      {label: 'Diretoria', field: 'diretoria', sortable: true, format: 'select', options: this.enumsService.diretorias, quickEdit: true},
      {label: 'Gerência', field: 'gerencia', sortable: true, format: 'text'},
      {label: 'Nº NOT', field: 'numeroNotificacao', sortable: true, format: 'text'},
      {label: 'Data NOT', field: 'dataNotificacao', sortable: true, format: 'daterange'},
      {label: 'Concessionária', field: 'concessionaria', sortable: true, format: 'select', options: this.enumsService.concessionarias, quickEdit: true},
      {label: 'Rodovia', field: 'rodovia', sortable: true, format: 'text'},
      {label: 'Item CFF', field: 'cff', sortable: true, format: 'text'},
      {label: 'Categoria', field: 'categoria', sortable: true, format: 'text'},
      {label: 'Descrição', field: 'descricao', sortable: true, format: 'text'},
      {label: 'Motivo', field: 'motivo', sortable: true, format: 'select', options: this.enumsService.motivos, quickEdit: true},
      {label: 'Status', field: 'status', sortable: true, format: 'status', options: this.enumsService.status, quickEdit: true},
      {label: 'Data Status', field: 'dataStatus', sortable: true, format: 'daterange'},
      {label: 'Fase', field: 'fase', sortable: true, format: 'select', options: this.enumsService.fases, quickEdit: true},
      {label: 'Data Fase', field: 'dataFase', sortable: true, format: 'daterange'},
      {label: 'Valor P0', field: 'valorP0', sortable: true, format: 'currency'},
      {label: 'Valor Atual', field: 'valorAtual', sortable: true, format: 'currency'},
      {label: 'Nº TAP', field: 'numeroTap', sortable: true, format: 'text'},
      {label: 'Tipo TAP', field: 'tipoTap', sortable: true, format: 'select', options: this.enumsService.tiposTap, quickEdit: true},
      {label: 'Data TAP', field: 'dataTap', sortable: true, format: 'daterange'},
      {label: 'Valor TAP', field: 'valorTap', sortable: true, format: 'currency'},
      {label: 'Situação TAP', field: 'situacaoTap', sortable: true, format: 'select', options: this.enumsService.situacoesTap, quickEdit: true},
      {label: 'Andamento', field: 'andamento', sortable: true, format: 'daterange', quickEdit: true},
      {label: 'Localização', field: 'localizacao', sortable: true, format: 'text'},
      {label: 'Infrações', field: 'infracoes', sortable: true, format: 'number'},
      {label: 'Grupo', field: 'grupo', sortable: true, format: 'select', options: this.enumsService.grupos, quickEdit: true},
      {label: 'Nível', field: 'nivel', sortable: true, format: 'select', options: this.enumsService.niveis, quickEdit: true},
      {label: 'Avanço', field: 'avanco', sortable: true, format: 'percent'},
      {label: 'Judicial', field: 'judicial', sortable: true, format: 'text'},
      {label: 'Observações', field: 'observacao', sortable: true, format: 'text'},
      {label: 'Curso', field: 'curso', sortable: true, format: 'select', options: this.enumsService.cursos, quickEdit: true},
    ];
  }
}
